<template>
	<div class="footer bg-white dkkkkk bottomStack" v-if="basicData && isAction" :class="setTabFixed  ? '' : ''" >
		<div class="divider"></div>
		<div class="container container--narrow pdb-0" v-if="basicData.goods"  >
			<div class="d-flex align-items-center justify-content-between pdt-9 pdb-10">
				<div class="d-flex align-items-baseline t-nowrap"  v-if="basicData.goods.paymentPrice > 0" >
					<div class="t-body-6 pdr-4">{{basicData.goods.currency.key || 'USD'}}</div>
					<div class="t-headline5 pdr-8  t-line-h-32">{{$n(basicData.goods.paymentPrice)}}</div>
				</div>
				<div class="d-flex align-items-baseline t-nowrap" v-else>
					<!-- <div class="t-body-6 pdr-4">KRW</div> -->
					<div class="t-headline5 pdr-8  t-line-h-32">{{$t('664')}}</div>
				</div>
				<div v-for="(action, index) in basicData.actions" :key="index" >
					<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText" :disabled="!action.enable" 
					@click="actionDegree(action)" @keypress="actionDegree(action)" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r t-nowrap">{{
						basicData.goods.paymentPrice > 0 ? 
							$t(action.translate, {str : $moment(action.translateParams.registerStart).format('L')}) :
							$t('665')
					}}</span>
					</button>
				</div>
			</div>
		</div>       

	</div>
</template>

<script>
/**
 * 차수 상세 푸터 컴포넌트(degree view footer component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import ViewHeader from './Header.vue'
import {MDCRipple} from '@material/ripple'
// import { MDCCircularProgress } from '@material/circular-progress';

export default {
	props: ['setTabFixed'],
	extends: ViewHeader,
	computed: {
	   isAction() {
		   return this.basicData.actions[0].enable
	   }
	},
	mounted() {
		//this.setTopAppBarHomeBlank(this.$t('66'))
		this.setMaterialUi()
		//const circularProgress = new MDCCircularProgress(document.querySelector('.mdc-circular-progress'));
	},
	methods: {
		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})

		},
	}
}
</script>